import React, { useState, useEffect, useRef } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";

function obtenerEstiloEstado(estado) {
  switch (estado) {
    case 0:
      return "bg-green-300 border-green-400";
    case 1:
      return "bg-yellow-200 border-yellow-400";
    case 2:
      return "bg-red-300 border-red-400";
    default:
      return "bg-gray-200 border-gray-300";
  }
}

function obtenerNombreEstado(estado) {
  switch (estado) {
    case 0:
      return "Normal";
    case 1:
      return "Falla";
    case 2:
      return "Falla Crítica";
    default:
      return "";
  }
}

function Sector() {
  const { equipoId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const equipoRaw = location.state?.equipo || localStorage.getItem("equipoActivo");
  const equipo = typeof equipoRaw === "string" ? JSON.parse(equipoRaw) : equipoRaw;
  const sectores = equipo?.sectores ?? [];

  const [estadoSectores, setEstadoSectores] = useState({});
  const [estadoValvulasPorSector, setEstadoValvulasPorSector] = useState({});
  const [modalVisible, setModalVisible] = useState(false);
  const [pinIngresado, setPinIngresado] = useState("");
  const [sectorSeleccionado, setSectorSeleccionado] = useState(null);
  const [pinError, setPinError] = useState("");
  const [mensajeValvulas, setMensajeValvulas] = useState("");
  const [mostrarMensaje, setMostrarMensaje] = useState(false);

  const pinInputRef = useRef();

  useEffect(() => {
    if (equipo) {
      localStorage.setItem("equipoActivo", JSON.stringify(equipo));
    }
  }, [equipo]);

  useEffect(() => {
    if (modalVisible) {
      setTimeout(() => {
        pinInputRef.current?.focus();
      }, 100);
    }
  }, [modalVisible]);

  const cambiarEstadoManual = (sectorId, nuevoEstado) => {
    setEstadoSectores((prev) => ({ ...prev, [sectorId]: nuevoEstado }));
  };

  const alternarValvulas = (sectorId) => {
    const sector = sectores.find((s) => s.sectorId === sectorId);
    if (!sector) return;

    const estadoActual = estadoValvulasPorSector[sectorId] ?? false;
    const nuevoEstado = !estadoActual;

    setEstadoValvulasPorSector((prev) => ({ ...prev, [sectorId]: nuevoEstado }));

    const listaValvulas = (sector.valvulas ?? [])
      .map((v) => `💧 ${v.codigo || "Válvula " + v.valvulaId}`)
      .join("\n");

    setMensajeValvulas(
      `Se ${nuevoEstado ? "activaron" : "desactivaron"} las siguientes válvulas del sector "${sector.sectorNombre}":\n${listaValvulas}`
    );
    setMostrarMensaje(true);
    setTimeout(() => setMostrarMensaje(false), 5000);
  };

  const handleClickSector = (sector) => {
    setSectorSeleccionado(sector);
    setPinIngresado("");
    setPinError("");
    setModalVisible(true);
  };

  const validarPin = () => {
    if (pinIngresado === "1747") {
      setModalVisible(false);
      navigate(`/valvula/${sectorSeleccionado.sectorId}`, {
        state: { sector: sectorSeleccionado, equipo },
      });
    } else {
      setPinError("PIN incorrecto");
    }
  };

  if (!equipo) {
    return (
      <div className="p-4">
        No se recibió la información del equipo (equipoId: {equipoId})
      </div>
    );
  }

  return (
    <div
      className="min-h-screen text-gray-800 font-sans relative overflow-x-hidden"
      style={{
        background: "linear-gradient(135deg, #e8ffef 0%, #c3f8ff 100%)"
      }}
    >
      {/* Onda decorativa SVG en la parte inferior */}
      <div className="absolute bottom-0 left-0 w-full pointer-events-none select-none z-0" style={{lineHeight:0}}>
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path fill="#86e2d5" fillOpacity="0.45" d="M0,60 C360,120 1080,0 1440,60 L1440,120 L0,120 Z"></path>
          <path fill="#a8e063" fillOpacity="0.27" d="M0,90 C400,60 1040,140 1440,90 L1440,120 L0,120 Z"></path>
          <path fill="#56c5e1" fillOpacity="0.15" d="M0,110 C480,80 960,160 1440,110 L1440,120 L0,120 Z"></path>
        </svg>
      </div>
      <main className="px-4 md:px-8 pb-16 mt-8 max-w-7xl mx-auto relative z-10">
        <section>
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-semibold text-[#2377b1]">
              Sectores del equipo <span className="font-bold">{equipo.moduloNombre}</span>
            </h2>
            <button
              onClick={() => navigate("/home")}
              className="inline-block px-4 py-2 bg-blue-200 text-blue-800 rounded-full font-semibold border border-blue-300 hover:bg-blue-300 hover:text-blue-900 transition"
            >
              ← Volver a equipos
            </button>
          </div>

          {sectores.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
              {sectores.map((sector) => {
                const estado = estadoSectores[sector.sectorId] ?? 0;
                const valvulasActivas = estadoValvulasPorSector[sector.sectorId] ?? false;

                return (
                  <div
                    key={sector.sectorId}
                    onClick={() => handleClickSector(sector)}
                    className="relative p-5 rounded-2xl border border-[#dbeafe] bg-white/90 shadow-md hover:shadow-xl hover:ring-2 hover:ring-blue-300 transition-all duration-200 cursor-pointer flex flex-col h-full min-h-[320px]"
                  >
                    {/* Nombre del sector en la esquina superior izquierda */}
                    <div className="absolute top-4 left-4 z-10">
                      <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-lg text-sm font-bold shadow">
                        {sector.sectorNombre}
                      </span>
                    </div>

                    {/* Gotita centrada en la parte superior */}
                    <div className="w-full flex justify-center absolute left-0 top-3 z-20 pointer-events-none select-none">
                      <span
                        className="text-blue-200"
                        style={{
                          fontSize: "2.7rem",
                          opacity: 0.17,
                          zIndex: 1,
                          lineHeight: "2.7rem",
                        }}
                      >
                        💧
                      </span>
                    </div>

                    {/* Cajita de información */}
                    <div className="relative z-10 flex-1 flex flex-col items-center justify-start mt-12">
                      <div className="w-full bg-gradient-to-b from-green-100 via-blue-50 to-blue-100 border border-blue-100 rounded-xl p-4 shadow-inner flex flex-col items-center">
                        <p className="text-sm text-gray-500 mb-3">
                          {sector.valvulas?.length ?? 0} válvula(s)
                        </p>
                        <div className="flex flex-col items-center mb-2">
                          <span className="text-xs font-medium text-gray-600 mb-1 text-center">
                            Estado: {obtenerNombreEstado(estado)}
                          </span>
                          <div className="flex gap-2">
                            {[0, 1, 2].map((estadoIndex) => (
                              <div
                                key={estadoIndex}
                                title={obtenerNombreEstado(estadoIndex)}
                                className={`w-6 h-6 rounded-full border-2 cursor-pointer shadow-sm transition
                                  ${estado === estadoIndex
                                    ? obtenerEstiloEstado(estadoIndex)
                                    : "bg-gray-50 border-gray-300"
                                  }`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  cambiarEstadoManual(sector.sectorId, estadoIndex);
                                }}
                              ></div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Control Manual abajo */}
                    <div className="relative z-10 mt-6 flex items-center gap-3 justify-center">
                      <div className="flex items-center text-sm text-gray-600">
                        <span className="mr-1">🔧</span>
                        <span>Control Manual</span>
                      </div>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          alternarValvulas(sector.sectorId);
                        }}
                        className={`text-sm px-3 py-1 rounded border-2 font-semibold shadow-sm transition
                          ${
                            valvulasActivas
                              ? "border-red-300 text-red-600 bg-red-100 hover:bg-red-200"
                              : "border-green-300 text-green-700 bg-green-100 hover:bg-green-200"
                          }`}
                      >
                        {valvulasActivas ? "Desactivar" : "Activar"} válvulas
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <p className="text-gray-500 mb-6">
              No hay sectores disponibles para este equipo.
            </p>
          )}

          {mostrarMensaje && (
            <div className="fixed bottom-6 right-6 bg-blue-100 border-l-4 border-blue-400 text-blue-900 rounded shadow-lg px-5 py-4 whitespace-pre-line z-50 animate-fade-in">
              {mensajeValvulas}
            </div>
          )}

          {modalVisible && (
            <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50 backdrop-blur-sm">
              <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-xs">
                <h3 className="text-lg font-bold mb-4 text-blue-900">🔐 Ingreso a Válvulas</h3>
                <input
                  ref={pinInputRef}
                  type="password"
                  placeholder="Ingrese PIN"
                  className="w-full border border-blue-200 px-3 py-2 rounded mb-3 focus:outline-blue-400"
                  value={pinIngresado}
                  onChange={(e) => setPinIngresado(e.target.value)}
                />
                {pinError && (
                  <p className="text-red-600 text-sm mb-2">{pinError}</p>
                )}
                <div className="flex justify-end gap-3">
                  <button
                    className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                    onClick={() => setModalVisible(false)}
                  >
                    Cancelar
                  </button>
                  <button
                    className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                    onClick={validarPin}
                  >
                    Ingresar
                  </button>
                </div>
              </div>
            </div>
          )}
        </section>
      </main>
    </div>
  );
}

export default Sector;